namespace Quote {

    import TripState = Core.Trip.TripState;

    interface RouteParams extends ng.route.IRouteParamsService
    {
        quoteNo :number;
        quoteRef :string;
    }

    export enum QuoteControllerStatus {
        Busy,
        NotFound,
        Ready,
        RefreshError,
        RefreshFailed
    }

    class QuotePublicController {

        public readonly controllerStatus = QuoteControllerStatus;
        public currentStatus :QuoteControllerStatus = QuoteControllerStatus.Busy;
        public priceDifference :number = 0;
        public priceDifferencePercentage :number = 0;
        public quote :Quote.IQuote;
        public trip :TripState;
        public validForDays :number = 30; //maybe the API should tell us this
        public hasEssentials :boolean = false;
        public productsLength :number = 0;
        public quoteStatusPromise: ng.IPromise<QuoteControllerStatus>;

        constructor(
            private $location :ng.ILocationService,
            private $routeParams :RouteParams,
            private analytics :any,
            private basketService :any,
            private basketStore :any,
            private bookingService :any,
            private dateUtil :any,
            private tripService :Core.TripService,
            private quoteService :QuoteService)
        {
            this.analytics.track('mixpanel', 'EmailMeLanding');
            const url = `${$routeParams.quoteRef}/${$routeParams.quoteNo}`;
            this.quoteStatusPromise = quoteService.getQuoteByReference(url)
            .then(quote => {
                if (!quote || quote.Error) {
                    return this.currentStatus = QuoteControllerStatus.NotFound;
                }

                //get the product ids
                const productIds = _.map(quote.Products,  (p :IQuoteProduct) => { return p.Id; });

                //seems that we can't do a single thing going forward without a trip being setup. As we are refreshing
                //the quote we might as well create a trip from the quote too. Unfortunately the trip service
                //relies on the basket and the basket is there until the refresh has happened :(
                return quoteService.refreshQuote(quote.Id, productIds).then(refreshedQuote => {
                    if (refreshedQuote.Error) {
                        return this.currentStatus = QuoteControllerStatus.RefreshError;
                    } else {
                        let restoreFailed = _.some(refreshedQuote.Products, {'RestoreFailed': true});
                        this.productsLength = refreshedQuote.Products.length;
                        if (restoreFailed) {
                            this.quote = quote;
                            return this.currentStatus = QuoteControllerStatus.RefreshFailed;
                        }
                        this.hasEssentials = _.some(
                            refreshedQuote.Products,
                            ({Ty}) => Ty === 'Transfer' || Ty === 'Car Hire' || Ty === 'Marhaba' || Ty === 'Insurance'
                        );
                        return tripService.getTripFromQuote(refreshedQuote).then(trip => {
                            this.trip = trip;
                            this.quote = refreshedQuote;
                            this.validForDays = quoteService.validForDays(refreshedQuote.Products);
                            this._setPriceDifference(refreshedQuote.Products);
                            return this.currentStatus = QuoteControllerStatus.Ready;
                        });
                    }
                });

            });
        }

        private _setPriceDifference(products): void {
            const {priceDifferenceAbs, priceDifferencePercentage} = this.quoteService.getPriceDifference(products);
            this.priceDifference = priceDifferenceAbs;
            this.priceDifferencePercentage = priceDifferencePercentage;
        }


        public searchAgain() :void {
            if (this.trip) {
                this.tripService.restoreSearchUnit(this.trip.TripId).then(() => {
                    this.$location.path('/holidays');
                });
            } else {
                this.$location.path('/');
            }
        };

        public bookQuote(position: string) :void {
            const bookingRedirectPath = 'holidays/book';
            const { BookingId, TripId } = this.trip;
            const { BasketId } = this.quote;

            this.basketService
                .bookBasket(TripId, BasketId);

            this.bookingService
                .prepareBooking(BasketId, BookingId, TripId)
                .then(() => {
                    this.$location.path(`${bookingRedirectPath}/${TripId}`);
                });

            if(position) {
                this.analytics.track('mixpanel', 'EmailMeBookButton', {position});
            }
        }

        public hideLoadingScreenOverlay() :boolean {
            const { quote, currentStatus, controllerStatus } = this;

            return quote && (currentStatus === controllerStatus.Ready ||
                currentStatus === controllerStatus.RefreshError ||
                currentStatus === controllerStatus.RefreshFailed);
        }
    }

    angular
        .module('quote')
        .controller('QuotePublic', QuotePublicController);

}
